import rangeSlider from 'range-slider-input';
import 'range-slider-input/dist/style.css';

export let 
	range,
	spans;
const form_input = document.querySelector('form#asideFilters .range-slider')
if(form_input){
	spans = [
		document.querySelector('form#asideFilters span.from'),
		document.querySelector('form#asideFilters span.to')
	]
	range = rangeSlider(form_input, {
		min: 0,
		max: 100,
		step: .1,
		value: [0, 30],
		onInput: function(values) {
			spans[0].textContent = values[0];
			spans[1].textContent = values[1];
		},
	});
}

export function setValue(value){
	range.value([value[0], value[1]])
	spans[0].textContent = value[0];
	spans[1].textContent = value[1];
}